import React from 'react';
import { connect } from 'react-redux';
import { withTranslator } from 'static/script/app/lang';
import { DialogModal } from 'components';
import PushSplash from './push-splash.svg';
import PropTypes from 'prop-types'; // ES6
import { WEB_PUSH_MODAL_TYPES } from 'tradera-constants/push-notifications';
import * as urbanairship from 'tradera-utils/urbanairship';
import GtmService from 'static/script/app/ui/google-tagmanager-service';

class PushNotificationModal extends React.PureComponent {
    handleClose = () => {
        this.props.closeModal();
    };

    trackGa(gaLabel) {
        GtmService.trackAction('Settings', 'Notifications', gaLabel);
    }

    async handleAccept(gaLabel) {
        const { memberId } = this.props;
        this.trackGa(gaLabel);
        this.props.closeModal();
        if ('UA' in window && memberId > 0) {
            await urbanairship.enableWebPush(memberId);
            await urbanairship.rememberPushNotificationSetting();
        }
    }

    handleReject = async () => {
        this.props.closeModal();
        this.trackGa('Decline - Opt-in alert');
        await urbanairship.disableWebPush();
        await urbanairship.rememberPushNotificationSetting();
    };

    render() {
        const { type } = this.props;
        let title = null,
            description = null,
            gaLabel;

        switch (type) {
            case WEB_PUSH_MODAL_TYPES.wishlist:
                gaLabel = 'Enable - Wishlist - Reminders (from alert)';
                title = 'Vill du få påminnelse innan annonser går ut?';
                description = (
                    <b>
                        Aktivera webnotiser för att få bättre koll på annonser i
                        din minneslista.
                    </b>
                );
                break;

            case WEB_PUSH_MODAL_TYPES.buyingListingOutbid:
                gaLabel = 'Enable - Buying - Outbid (from alert)';
                title = 'Vill du får notis om någon lägger ett högre bud?';
                description =
                    'Aktivera webnotiser för att få bättre koll på dina pågående budgivningar.';
                break;

            case WEB_PUSH_MODAL_TYPES.sellingListingFirstBid:
                gaLabel = 'Enable - Selling - First bid (from modal)';
                title =
                    'Vill du få webnotis när någon lägger ett bud på din vara?';
                description =
                    'Aktivera webnotiser för att få bättre koll på dina aktiva annonser';
                break;
            case WEB_PUSH_MODAL_TYPES.sellingListingAllBids:
                gaLabel = 'Enable - Selling - All bids (from alert)';
                title = 'Vill du få en notis för varje enskilt nytt bud?';
                break;

            case WEB_PUSH_MODAL_TYPES.default:
                gaLabel = 'Enable - Default (from alert)';
                title = 'Tradera är bättre med notiser! ';
                description =
                    'Tillåt notiser och få uppdateringar för alla dina köp-och säljaktiviteter på Tradera. ';
                break;
        }
        return (
            <DialogModal onDismiss={this.handleClose} mobileFullscreen={false}>
                <div className="text-center p-5" style={{ maxWidth: '40rem' }}>
                    <h3 className="pb-5">{title}</h3>
                    <img src={PushSplash} className="pb-5" />
                    <p className="pb-5">
                        {description} Du kan närsomhelst stänga av denna
                        funktion under inställningar.
                    </p>

                    <div className="row">
                        <div className="col-6">
                            <button
                                className="btn btn-outline-primary btn-fluid"
                                onClick={this.handleReject}>
                                Kanske senare
                            </button>
                        </div>
                        <div className="col-6">
                            <button
                                className="btn btn-primary btn-fluid"
                                onClick={() => this.handleAccept(gaLabel)}>
                                Ja
                            </button>
                        </div>
                    </div>
                </div>
            </DialogModal>
        );
    }
}

PushNotificationModal.propTypes = {
    memberId: PropTypes.number,
    type: PropTypes.oneOf([
        WEB_PUSH_MODAL_TYPES.default,
        WEB_PUSH_MODAL_TYPES.wishlist
    ])
};

const mapStateToProps = state => ({
    memberId: state.member.memberId
});

export default connect(mapStateToProps)(withTranslator(PushNotificationModal));
